/**
 * useQueueCount — polls GET /api/queue every 10s and returns the combined
 * active+pending scan count for the Header/QueuePage badge.
 *
 * Extracted out of App.tsx verbatim (issue #416): same guard (resets to 0
 * and skips fetching when auth is enabled and the caller is signed out),
 * same swallow-and-retry-on-next-tick behavior on a failed request.
 */
import { useState, useEffect } from 'react';
import { getQueueStatus } from '../utils/api';

const POLL_INTERVAL_MS = 10_000;

export function useQueueCount(authEnabled: boolean, isSignedIn: boolean): number {
  const [queueCount, setQueueCount] = useState(0);

  useEffect(() => {
    if (authEnabled && !isSignedIn) {
      setQueueCount(0);
      return;
    }

    const pollQueue = async () => {
      try {
        const qs = await getQueueStatus();
        setQueueCount(qs.active.length + qs.pending.length);
      } catch {
        // API may not be available
      }
    };
    pollQueue();
    const timer = setInterval(pollQueue, POLL_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [authEnabled, isSignedIn]);

  return queueCount;
}
